import React from "react";
import { useTranslation } from "react-i18next";

const PaymentDetails = (props) => {
  const {
    transactionId,
    orderId,
    orderUser,
    amount,
    currency,
    payeeFirstname,
    payeeLastname,
    merchantName,
    merchantAddress,
  } = props.transaction;
  const {
    paymentLogo,
    paymentName,
    tosConsent,
    setTosConsent,
    onStartPayment,
    cancelEnabled = false,
    onCancelPayment,
  } = props;

  const { t } = useTranslation();

  return (
    <div>
      <div className='d-flex my-3 opacity-6'>
        <div className='col-4 px-0 text-left'>
          <strong>{t("transaction_id")}</strong>
        </div>
        <div className='col-8 px-0 text-right'>{transactionId}</div>
      </div>

      <div className='d-flex mt-3 opacity-7'>
        <div className='col-6 px-0 text-left'>
          <strong>{t("order-id")}</strong>
        </div>
        <div className='col-6 px-0 text-right'>{orderId || "<" + t("undefined") + ">"}</div>
      </div>
      <div className='d-flex mb-3 opacity-7'>
        <div className='col-5 px-0 text-left'>
          <strong>{t("user")}</strong>
        </div>
        <div className='col-7 px-0 text-right'>{orderUser || "<" + t("undefined") + ">"}</div>
      </div>

      <div className='d-flex mb-3 text-danger'>
        <div className='col-6 px-0 text-left h4'>
          <strong>{t("amount")}</strong>
        </div>
        <div className='col-6 px-0 text-right h4'>
          <strong>
            {parseFloat(amount).toFixed(2)} {currency}
          </strong>
        </div>
      </div>

      <strong>{t("selected-payment")}</strong>
      <div className='text-center my-3'>
        <a href='#/' onClick={(e) => e.preventDefault()} className='active m-2 py-2 btn-input-select'>
          {paymentLogo}
          <div className='font-weight-bold my-1'>{t("payname." + paymentName)}</div>
        </a>
      </div>

      <div className='d-flex my-3'>
        <div className='col-4 px-0 text-left'>
          <strong>{t("payee")}</strong>
        </div>
        <div className='col-8 px-0 text-right'>
          {payeeFirstname} {payeeLastname}
        </div>
      </div>
      <div className='form-check my-3'>
        <input
          className='form-check-input'
          type='checkbox'
          value=''
          id='tosConsent'
          checked={tosConsent}
          onChange={(e) => setTosConsent(e.target.checked)}
        />
        <label className='form-check-label opacity-6' htmlFor='flexCheckChecked'>
          {t("tos-consent")}{" "}
        </label>
      </div>
      <div className='text-center'>
        {cancelEnabled && (
          <button type='button' className='btn btn-outline-info px-5 my-3 mr-3' onClick={onCancelPayment}>
            {t("cancel")}{" "}
          </button>
        )}
        <button type='button' className='btn btn-danger px-5 my-3' disabled={!tosConsent} onClick={onStartPayment}>
          {t("pay")}{" "}
        </button>
      </div>

      <div className='d-flex my-3 opacity-6'>
        <div className='col-4  px-0'>
          <strong>{t("payment-for")}</strong>
        </div>
        <div className='col-8 px-0 text-right'>{merchantName}</div>
      </div>
      <div className='d-flex my-3 opacity-6'>
        <div className='col-4  px-0'>
          <strong>{t("address")}</strong>
        </div>
        <div className='col-8 px-0 text-right'>{merchantAddress}</div>
      </div>
    </div>
  );
};

export default PaymentDetails;
